import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';
import { engineKeys } from '../keys';

export const useEngine = (id: number | null) => {
  return useQuery({
    queryKey: id ? engineKeys.detail(id) : [],
    queryFn: () => {
      if (!id) throw Error('No engine ID provided');
      return api.request(endpoints.engines.get(id));
    },
    enabled: !!id && id > 0,
  });
};
